// Story 8.8 (AC1/AC3) — the read-only case log's data source (Screen 18). SELF-only
// read: the BE resolves the caller from the auth context (no clinician_id param
// exists on the wire). A 404 (CAL-LOG-404 — unknown case / not scored yet) renders
// the screen's calm info Banner; retry: false keeps calibration an online-only
// surface (8.7 posture — no offline draft store here).

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { CalibrationCaseLogData } from "@/hooks/queries/calibration-log-types";

export const CALIBRATION_CASE_LOG_QUERY_KEY = "calibration-case-log";

export function useCalibrationCaseLog(caseId: string | undefined) {
  return useQuery({
    queryKey: [CALIBRATION_CASE_LOG_QUERY_KEY, caseId],
    queryFn: () =>
      apiFetch<CalibrationCaseLogData>(
        `/calibration/cases/${encodeURIComponent(caseId ?? "")}/log`,
      ),
    enabled: Boolean(caseId),
    retry: false,
  });
}
